import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import moment from "moment";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import EllipsisText from "react-ellipsis-text";

const Requests = () => {
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 100;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddUser = () => {
    navigate("/admin/settings/users-and-permissions/new");
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[
            { label: "Name", value: "name" },
            { label: "Email", value: "email" },
          ]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleEdit = (id) => {
    navigate(`/admin/settings/users-and-permissions/${id}`);
  };

  const switchStatus = (param) => {
    switch (String(param)) {
      case "1":
        return "Pending";
      case "2":
        return "Approved";
      case "3":
        return "Rejected";
      default:
        return "";
    }
  };
  const switchStatusColor = (param) => {
    switch (String(param)) {
      case "1":
        return "default";
      case "2":
        return "success";
      case "3":
        return "critical";
      default:
        return "";
    }
  };
  const handleClickRow = (param) => {
    window.open(`/admin/requests/${param}`, "_blank");
  };
  useEffect(() => {
    fetchData();
  }, [ts, availability, queryValue, page]);

  async function fetchData() {
    let responseUsers = "";
    let responseFeatures = [];

    try {
      responseUsers = await axios.get(
        `/requests?per_page=${perPage}&page=${refBoolPage.current ? page : 1}${
          queryValue
            ? `&filter[${
                availability === "" ? "email" : availability
              }]=${queryValue}`
            : ""
        }`
      );
      setPageObject({
        ...pageObject,
        tableItems: responseUsers.data.data.data.map((item, index) => [
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.id}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.user && item?.user?.id !== null ? item?.user?.id : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.user && item?.user?.name ? item?.user?.name : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.user && item?.user?.phone ? item?.user?.phone : "-"}
          </div>,

          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.created_at
              ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
              : "-"}
          </div>,
          <Badge tone={switchStatusColor(item.status.id)}>
            {switchStatus(item.status.id)}
          </Badge>,
        ]),
        isLoading: false,
        isListEmpty: !responseUsers.data.data.data.length ? true : false,
        tableTotalPages: responseUsers.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This user has been successfully deleted"
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;

  return (
    <Page title="Requests" fullWidth>
      <Card padding="0">
        {loadingMarkup}

        <Filters
          queryValue={queryValue}
          queryPlaceholder="Search..."
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        />

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium">
              ID
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              User ID
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              User
            </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Email
            // </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Phone
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Created at
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Status
            </Text>,
          ]}
          rows={pageObject.tableItems}
          verticalAlign="middle"
          increasedTableDensity
          footerContent={
            pageObject.tableItems?.length &&
            `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
          }
          hasZebraStripingOnData
        />
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}

        {toastMarkup}
      </Card>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default Requests;
